import { FC, PropsWithChildren } from 'react';
import styles from './InlineFilterColumn.css';

export const InlineFilterColumn: FC<PropsWithChildren> = ({ children }) => {
  return <div className={styles['column']}>{children}</div>;
};
